<template>
<BlockConfig title="modalità di funzionamento"
    :valid="valid"
    @handleSave="handleSave"
    @restore="restore">
    <v-form v-model="valid">
        <div class="d-flex my-2">
            <v-radio-group v-model="config_data.selected_mode">
                <v-radio label="In service" value="service"></v-radio>
                <v-radio label="In installation" value="installation"></v-radio>
            </v-radio-group>
        </div>
    </v-form>
</BlockConfig>
</template>
<script>
import {ConfigMixin} from '../../../utils/configMixin_new'
import BlockConfig from '../../../components/utils/BlockConfig'

export default {
    components: {BlockConfig},
    mixins: [ConfigMixin],
    data() {
        return {
           o_data: {
               selected_mode: "service"
           }
        }
    },
    methods: {
        handleSave(){
            this.$parent.$emit('updateBlock', {b_idx: this.data.index, b_id: this.data.block._id, conf: this.config_data, selected_mode: this.config_data.selected_mode})
        }
    },
}
</script>